import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { WorkflowData } from "../../../models/applications.models";
import { LoaderService } from "../../../../common/services/loader.service";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";

@Component({
    selector: 'app-stratigraphic-home',
    templateUrl: './stratigraphic-home.component.html',
    styleUrls: ['./stratigraphic-home.component.scss'],
    standalone: false
})
export class StratigraphicHomeComponent implements OnInit, OnDestroy {



    constructor() { }

    ngOnInit() {
       

    }

    ngOnDestroy() {
    }

}
